"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CompetencyAssignmentLevelGapFilter () {
        return CompetencyAssignmentLevelGapFilter;
    },
    get CompetencyAssignmentSortBy () {
        return CompetencyAssignmentSortBy;
    },
    get CompetencyAssignmentSourceFilter () {
        return CompetencyAssignmentSourceFilter;
    },
    get CompetencyAssignmentStatusFilter () {
        return CompetencyAssignmentStatusFilter;
    },
    get ExportCompetencyAssignmentsCsvQuery () {
        return ExportCompetencyAssignmentsCsvQuery;
    },
    get ExportCompetencyAssignmentsCsvQueryBase () {
        return ExportCompetencyAssignmentsCsvQueryBase;
    },
    get ListAssignmentHistoryQuery () {
        return ListAssignmentHistoryQuery;
    },
    get ListCompanyCompetencyAssignmentsQuery () {
        return ListCompanyCompetencyAssignmentsQuery;
    },
    get ListCompetencyAssignmentsQuery () {
        return ListCompetencyAssignmentsQuery;
    },
    get ListTeamCompetencyAssignmentsQuery () {
        return ListTeamCompetencyAssignmentsQuery;
    },
    get TeamCompetencyAssignmentSortBy () {
        return TeamCompetencyAssignmentSortBy;
    },
    get UpdateCurrentLevelBody () {
        return UpdateCurrentLevelBody;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _base = require("../base");
const CompetencyAssignmentSourceFilter = _zod.z.enum([
    "any",
    ..._models.CompetencyAssignmentSourceSchema.options
]).default("any");
const CompetencyAssignmentStatusFilter = (0, _base.createStatusFilterSchema)(_models.CompetencyAssignmentStatusSchema.unwrap().options);
const CompetencyAssignmentLevelGapFilter = _models.CompetencyLevelGapSchema;
const CompetencyAssignmentSortBy = _zod.z.enum([
    "competency_name",
    "expected_level",
    "current_level"
]);
const TeamCompetencyAssignmentSortBy = _zod.z.enum([
    "assignee_name",
    "competency_name",
    "expected_level",
    "current_level"
]);
const SortOrder = _zod.z.enum([
    "asc",
    "desc"
]).default("asc");
const ListCompetencyAssignmentsQuery = _zod.z.object({
    employeeId: _utilsisomorphic.transformObjectId.optional(),
    search: _zod.z.string().trim().optional(),
    source: CompetencyAssignmentSourceFilter,
    status: CompetencyAssignmentStatusFilter,
    levelGap: (0, _utilsisomorphic.transformStringToArray)(CompetencyAssignmentLevelGapFilter).optional(),
    sortBy: CompetencyAssignmentSortBy.default("competency_name"),
    sortOrder: SortOrder,
    limit: _zod.z.coerce.number().int().min(1).max(500).default(25),
    skip: _zod.z.coerce.number().int().min(0).default(0)
});
const ListTeamCompetencyAssignmentsQuery = _zod.z.object({
    // The team subject (whose direct reports to list); defaults to the caller.
    employeeId: _utilsisomorphic.transformObjectId.optional(),
    search: _zod.z.string().trim().optional(),
    source: CompetencyAssignmentSourceFilter,
    status: CompetencyAssignmentStatusFilter,
    levelGap: (0, _utilsisomorphic.transformStringToArray)(CompetencyAssignmentLevelGapFilter).optional(),
    assigneeId: _utilsisomorphic.transformObjectId.optional(),
    competencyId: _utilsisomorphic.transformObjectId.optional(),
    // Multi-select: filters team members by their OWN role (the "Role" custom field), not assignment.role_id.
    roleIds: (0, _utilsisomorphic.transformStringToArray)(_utilsisomorphic.transformObjectId).optional(),
    sortBy: TeamCompetencyAssignmentSortBy.default("assignee_name"),
    sortOrder: SortOrder,
    limit: _zod.z.coerce.number().int().min(1).max(500).default(25),
    skip: _zod.z.coerce.number().int().min(0).default(0)
});
const ListAssignmentHistoryQuery = _zod.z.object({
    limit: _zod.z.coerce.number().int().min(1).max(500).default(50),
    skip: _zod.z.coerce.number().int().min(0).default(0)
});
const UpdateCurrentLevelBody = _zod.z.object({
    current_level: _zod.z.number().int().min(1).max(_models.MAX_COMPETENCY_LEVELS).nullable()
});
const ListCompanyCompetencyAssignmentsQuery = _zod.z.object({
    search: _zod.z.string().trim().optional(),
    source: CompetencyAssignmentSourceFilter,
    status: CompetencyAssignmentStatusFilter,
    levelGap: (0, _utilsisomorphic.transformStringToArray)(CompetencyAssignmentLevelGapFilter).optional(),
    assigneeId: _utilsisomorphic.transformObjectId.optional(),
    competencyIds: (0, _utilsisomorphic.transformStringToArray)(_utilsisomorphic.transformObjectId).optional(),
    // Multi-select: filters assignees by their OWN role (the "Role" custom field), not assignment.role_id.
    roleIds: (0, _utilsisomorphic.transformStringToArray)(_utilsisomorphic.transformObjectId).optional(),
    sortBy: TeamCompetencyAssignmentSortBy.default("competency_name"),
    sortOrder: SortOrder,
    limit: _zod.z.coerce.number().int().min(1).max(500).default(25),
    skip: _zod.z.coerce.number().int().min(0).default(0)
});
const ExportCompetencyAssignmentsCsvQueryBase = _zod.z.object({
    scope: _zod.z.enum([
        "employee",
        "team",
        "company"
    ]),
    employeeId: _utilsisomorphic.transformObjectId.optional(),
    search: _zod.z.string().trim().optional(),
    source: CompetencyAssignmentSourceFilter,
    status: CompetencyAssignmentStatusFilter,
    levelGap: (0, _utilsisomorphic.transformStringToArray)(CompetencyAssignmentLevelGapFilter).optional(),
    assigneeId: _utilsisomorphic.transformObjectId.optional(),
    competencyIds: (0, _utilsisomorphic.transformStringToArray)(_utilsisomorphic.transformObjectId).optional(),
    roleIds: (0, _utilsisomorphic.transformStringToArray)(_utilsisomorphic.transformObjectId).optional(),
    sortBy: _zod.z.union([
        CompetencyAssignmentSortBy,
        TeamCompetencyAssignmentSortBy
    ]).optional(),
    sortOrder: SortOrder
});
const ExportCompetencyAssignmentsCsvQuery = ExportCompetencyAssignmentsCsvQueryBase.superRefine((query, ctx)=>{
    if (query.scope !== "company" && (query.competencyIds?.length ?? 0) > 1) {
        ctx.addIssue({
            code: _zod.z.ZodIssueCode.custom,
            path: [
                "competencyIds"
            ],
            message: 'competencyIds accepts at most one id unless scope is "company"'
        });
    }
});
